<template>
	<div>
		<div
			style="
				position: fixed;
				top: 60px;
				z-index: 10000;
				left: 0px;
				backdrop-filter: blur(2px);
			"
			v-if="mainLoader"
		>
			<Spinner />
		</div>
		<div
			class="cand-dashboard-maincontainer height-100dvh mob-padding-0"
			:class="{
				'cand-dashboard-maincontainer-loggedout-asmnt': !hasAccess(),
			}"
		>
			<div
				class="topmob-header mob-back-header d-flex justify-content-start align-items-center"
				id="hideinlaptop"
			>
				<img
					class="mr-3"
					src="../../assets/mobile/assprog/mobileBackArrow.svg"
					alt=""
					@click="handleBack"
				/>
				All Assessment
			</div>
			<div class="cand-header d-flex" id="hideinmobile">
				<div class="mr-3 pointer">
					<img
						@click="handleBack"
						src="../../assets/img/homepage/back-arrow-blue.svg"
					/>
				</div>
				All Assessment
			</div>
			<div class="mt-2 d-flex max-1825 gap-2">
				<div style="width: 25%" id="hideinmobile">
					<AssessmentFilter
						@apply="handleApplyFilters"
						@clear="clearFilters"
						:topics="stableTopics"
						:maxPricerange="maxFinalPriceCombined"
					/>
				</div>

				<div class="w-75 mob-w-100 pr-2 mob-padding-0">
					<div
						class="px-2"
						:class="{
							'asp-left-loggedout asp-left-container': !hasAccess() && isLaptop,
							'asp-left-container': isLaptop,
							'padding-top-55px': !isLaptop && isApp,
							'asp-mobleft-container': !isLaptop,
						}"
					>
						<div
							class="d-flex w-100 align-items-center mt-2"
							:class="{
								'search-box-bluecont': isLaptop,
								'mb-3': !hasAccess() && !isLaptop,
							}"
						>
							<div
								class="position-relative js-input w-50 mob-w-100 mr-4 mob-mr-0"
							>
								<img
									class="lap-resumes-search-image-position"
									src="../../assets/newdesign/jobsearch/blueSearch.svg"
									alt=""
								/>
								<b-form-input
									class="resumes-search-input"
									placeholder="Search"
									type="search"
									clearable
									style="
										padding: 9px 15px 9px 35px !important;
										background: #ffffff !important;
										border: 0.5px solid #c4c4c4 !important;
										border-radius: 12px !important;
									"
									v-model="searchQuery"
									@keyup.enter="handleSearch"
									@input="handleInput"
								>
								</b-form-input>
							</div>
							<div class="position-relative" id="hideinlaptop">
								<img
									@click="$bvModal.show('asmntfilter')"
									class="ml-1"
									src="../../assets/assessment/roundedfilter.svg"
									alt=""
								/>
								<div
									v-if="filterCount > 0"
									class="red-dot-filter position-absolute text-white fam-lato fw-LM fs-12"
								>
									{{ filterCount }}
								</div>
							</div>
							<b-button
								class="candash-addBtn px-4"
								id="hideinmobile"
								@click="handleSearch"
								>Search</b-button
							>
						</div>
						<div
							v-if="hasAccess()"
							class="d-flex mt-3 mb-3 laptop-lb-tabs align-items-center gap-3"
						>
							<div
								v-for="tab in assessmentTabs"
								:key="tab.value"
								:class="{
									'lap-tabs-game-sel fs-13': activeAssessmentTab === tab.value,
									'lap-tabs-game-unsel color-2E425D fs-13 fw-R fam-mont':
										activeAssessmentTab !== tab.value,
									'text-center w-50px justify-content-center align-items-center':
										tab.label === 'All',
								}"
								@click="activeAssessmentTab = tab.value"
								class="pointer"
							>
								<span>{{ tab.label }}</span>
							</div>
						</div>

						<div
							class="assesspro-overflow pt-0"
							id="public-assessments"
							@scroll="onScroll"
							:class="{
								'cuo-assesspro-height': activeAssessmentTab !== 'all',
								'assesspro-overflow-loggedout': !hasAccess(),
							}"
						>
							<!--SHIMMER -->
							<div v-show="isLoadingAssessments && !loadingMore">
								<div
									v-for="i in 6"
									:key="i"
									class="mb-2 p-3"
									style="
										background: #fcfcfc;
										border-radius: 8px;
										box-shadow: 0px 2px 8px #00000014;
									"
								>
									<div class="d-flex align-items-start">
										<!-- Left Icon -->
										<b-skeleton
											type="avatar"
											width="60px"
											height="60px"
											class="mr-3"
										/>

										<!-- Right Content -->
										<div class="flex-grow-1">
											<!-- Title -->
											<b-skeleton width="60%" height="18px" class="mb-2" />

											<!-- Topic -->
											<b-skeleton width="40%" height="14px" class="mb-3" />

											<!-- Bottom row -->
											<div
												class="d-flex justify-content-between align-items-center"
											>
												<!-- View Marks -->
												<b-skeleton width="90px" height="14px" />

												<!-- Duration + Level -->
												<div class="d-flex gap-3">
													<b-skeleton width="60px" height="14px" />
													<b-skeleton width="60px" height="14px" />
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>

							<!-- DATA -->

							<div v-show="!isLoadingAssessments || loadingMore">
								<template
									v-if="filteredAssessments && filteredAssessments.length"
								>
									<AssessmentCard
										v-for="assessment in filteredAssessments"
										:key="assessment.assessmentID"
										:assessment="assessment"
										:fromAsmntprogress="true"
										:cardType="activeAssessmentTab"
										:isProject="isProjectAssessment(assessment)"
										class="mb-2"
										:attemptedTag="true"
									/>
								</template>
							</div>
							<!--EMPTY STATE -->
							<div
								v-if="!isLoadingAssessments && !filteredAssessments.length"
								class="w-100 cat-overflow d-flex flex-column align-items-center justify-content-center h-100"
							>
								<img
									src="../../assets/newdesign/jobsearch/searchNotFound.svg"
								/>
								<span class="js-empty-font mt-3"> No assessment found </span>
							</div>
							<div
								v-if="loadingMore"
								id="hideinlaptop"
								class="d-flex justify-content-center"
							>
								<b-spinner label="Loading..."></b-spinner>
							</div>
						</div>

						<div
							id="hideinmobile"
							v-if="activeAssessmentTab === 'all'"
							class="acs-paginaTion-new d-flex justify-content-between align-items-center mobile-hide-pagination"
						>
							<div class="d-flex">
								<span class="acs-gotopage-text mr-2 p-1">Go to page</span>
								<div class="acs-pagination-num">
									<b-form-input
										class="no-number"
										type="number"
										v-model="pageNumberToGo"
										@keydown="checkDigit"
										@keyup.enter="goToPage(pageNumberToGo)"
									>
									</b-form-input>
								</div>
								<div class="acs-pagination-addbtn">
									<!-- :disabled="!isValidPage(pageNumberToGo)" -->
									<b-button @click="goToPage(pageNumberToGo)">
										<img
											src="../../assets/newdesign/assessPro/page-arrow.svg"
											alt=""
										/>
									</b-button>
								</div>
							</div>
							<div class="d-flex justify-content-center pagination ml-135">
								<b-pagination
									:total-rows="total"
									:per-page="pageCount"
									@change="onPageChange"
									v-model="currentPage"
									align="center"
									first-number
									last-number
									limit="4"
								>
									<template #prev-text
										><span
											><img
												src="../../assets/newdesign/assessPro/pageLeft.svg"
												alt=""
											/> </span
									></template>
									<template #next-text
										><span
											><img
												src="../../assets/newdesign/assessPro/pageRight.svg"
												alt="" /></span
									></template>
								</b-pagination>
							</div>
							<div class="d-flex align-items-center">
								<PaginationCountSelect
									:pagecount="pageCount"
									@update-value="updatePageCount"
								/>
								<div
									class="acs-gotopage-text mr-2 ml-4 d-flex align-items-center justify-content-end"
								>
									Results :
									<span class="ml-1">
										{{ pageStart }}
									</span>
									<span class="ml-1"> - {{ pageEnd }} </span>
									<span class="pl-1"></span> of <span class="pr-1"></span
									>{{ total }}
								</div>
							</div>
						</div>
					</div>
				</div>
				<!-- <AssessmentSidePanel /> -->
			</div>
		</div>
		<AssessmentMarksModal
			:showMarks="showAssessmentMarks"
			:selectedAssessment="selectedAssessment"
			:isPublic="isPublic"
			@closeModal="
				showAssessmentMarks = false;
				clearSourceQuery();
			"
			@take-next-attempt="
				viewTestDetails(
					selectedAssessment,
					isPublic == true ? 'public' : 'private'
				)
			"
		/>
		<TestDetails
			v-if="showTestDetails"
			:showTestDetails="showTestDetails"
			:selectedAssessment="selectedAssessment"
			:public="isPublic"
			@closeTestModal="
				showTestDetails = false;
				clearSourceQuery();
			"
		/>
		<b-modal
			hide-footer
			hide-header
			id="asmntfilter"
			modal-class="bottom-modal asmnt-filter-modal"
		>
			<!-- no-close-on-backdrop -->
			<AssessmentFilter
				:key="JSON.stringify(filters)"
				:appliedFilters="filters"
				@apply="handleApplyFilters"
				@clear="clearFilters"
				:topics="stableTopics"
				:maxPricerange="maxFinalPriceCombined"
				@filter-count="handleFilterCount"
			/>
		</b-modal>
	</div>
</template>

<script>
import assessmentProgress from "@/components/mixin/assessmentProgress.js";
import Spinner from "@/components/fixedcomponents/Spinner.vue";
import ProgressBar from "@/components/ProgressBar.vue";
import PaginationCountSelect from "@/components/PaginationCountSelect.vue";
import Select from "@/components/Filter/Select.vue";
import AssessmentSidePanel from "@/components/Assessment/AssessmentSidePanel.vue";
import AssessmentMarksModal from "./AssessmentMarksModal.vue";
import TestDetails from "./TestDetailsAP.vue";
import EventBus from "../../utils/EventBus";
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/default.css";
import AssessmentCard from "@/components/Assessment/AssessmentCard.vue";
import AssessmentFilter from "@/components/Assessment/AssessmentFilter.vue";
import { getPublicAssessments, getAllAssessments } from "@/utils/apiFunctions";
import { mapGetters } from "vuex";
import { hasAccess } from "@/utils/tokenCheck";
import { Capacitor } from "@capacitor/core";

export default {
	name: "LaptopAssessmentProgress",
	components: {
		Spinner,
		ProgressBar,
		PaginationCountSelect,
		Select,
		AssessmentSidePanel,
		AssessmentMarksModal,
		TestDetails,
		VueSlider,
		AssessmentCard,
		AssessmentFilter,
	},
	mixins: [assessmentProgress],

	data() {
		return {
			allAssessmentsMaxPrice: 0,
			isLoadingAssessments: false,
			showfilterModal: false,
			isLaptop: true,
			activeAssessmentTab: "all",
			assessmentTabs: [
				{ label: "All", value: "all" },
				{ label: "Completed", value: "completed" },
				{ label: "Upcoming", value: "upcoming" },
				{ label: "Ongoing", value: "ongoing" },
			],

			options: [
				{ text: "Orange", value: "orange" },
				{ text: "Apple", value: "apple" },
				{ text: "Pineapple", value: "pineapple" },
				{ text: "Grape", value: "grape" },
			],
			publicAssessment: [],
			allAssessmentsData: {
				completed: [],
				upcoming: [],
				ongoing: [],
			},
			filters: {},
			searchQuery: "",
			count: 10,
			currentPage: 1,
			pageNumberToGo: null,
			total: 0,
			pageStart: 0,
			pageEnd: 0,
			pageCount: 10,
			topics: [],
			maxPricerange: 0,
			loadingMore: false,
			filterCount: 0,
			stableTopics: [],
			isTopicsInitialized: false,
			skipWatcher: false,
			// isManualClear: false,
		};
	},
	async created() {
		this.createdActions();
		this.checkScreenSize(); // Check screen size initially
		this.isLoadingAssessments = true;
		window.addEventListener("resize", this.checkScreenSize); // Add event listener for window resize

		EventBus.$on("search", this.searchPublic);
		EventBus.$on("login-success", this.createdActions);
		EventBus.$on("onboarding-fetch-post-login", this.createdActions);
		// EventBus.$on("clear-inner-search", () => {
		// 	this.searchQuery = "";
		// 	this.isManualClear = true;
		// });
		// this.pageCount = Number(this.$route.query.count) || 20;
		// this.currentPage = Number(this.$route.query.page) || 1;
		if (this.search) EventBus.$emit("updateSearchQuery", this.search);
		// }
	},
	beforeUnmount() {
		window.removeEventListener("resize", this.checkScreenSize); // Remove event listener before component unmounts
	},
	beforeDestroy() {
		EventBus.$off("search", this.searchPublic);
		EventBus.$off("login-success", this.createdActions);
		EventBus.$off("onboarding-fetch-post-login", this.createdActions);
		EventBus.$off("clear-inner-search");
	},
	computed: {
		...mapGetters("userVUEX", {
			userInfo: "getUserInfo",
		}),
		isApp(){
			return Capacitor.isNativePlatform();
		},
		allTopics() {
			const topicsSet = new Set();

			//  from API (public)
			(this.topics || []).forEach((t) => topicsSet.add(t));

			// from all assessments
			this.allAssessmentsCombined.forEach((item) => {
				const topic = item.topicName || item.topicTitle;
				if (topic) topicsSet.add(topic);
			});

			return Array.from(topicsSet);
		},
		allAssessmentsCombined() {
			return [
				...(this.publicAssessment || []),
				...(this.allAssessmentsData.completed || []),
				...(this.allAssessmentsData.upcoming || []),
				...(this.allAssessmentsData.ongoing || []),
			];
		},
		maxFinalPriceCombined() {
			return Math.max(
				this.maxPricerange || 0,
				this.allAssessmentsMaxPrice || 0
			);
		},
		filteredAssessments() {
			switch (this.activeAssessmentTab) {
				case "completed":
					return this.allAssessmentsData.completed;

				case "upcoming":
					return this.allAssessmentsData.upcoming;

				case "ongoing":
					return this.allAssessmentsData.ongoing;

				default:
					return this.publicAssessment;
			}
		},
	},
	methods: {
		hasAccess() {
			return hasAccess();
		},
		async createdActions() {
			this.loaderStatus = true;
			this.loaderSide = true;
			const { tab } = this.$route.query;
			const { from, categoryIDs, filterType } = this.$route.query;
			const { searchQuery, source } = this.$route.query;
			if (tab) {
				this.activeAssessmentTab = tab;
				await this.getAllAssessments();
				await this.getPublicAssessments();
			} else if (searchQuery) {
				this.searchQuery = searchQuery;
				await this.getAllAssessments();
				await this.getPublicAssessments();
			} else if (
				from == "viewAllassessments" ||
				(!from && !categoryIDs) ||
				from == "profilevisibility" ||
				from == "candidate" ||
				from == "streaks"
			) {
				this.searchQuery = searchQuery;
				await this.getAllAssessments();
				await this.getPublicAssessments();
			}
			// Auto-open marks or test details modals when navigating from assessmentCard/trendingTag
			const AUTO_OPEN_SOURCES = ["assessmentCard", "trendingTag"];
			if (AUTO_OPEN_SOURCES.includes(source) && searchQuery) {
				if (this.isPageRefresh()) {
					this.clearSourceQuery();
				} else {
					this.autoOpenAssessment(searchQuery);
				}
			}
			// filterType (practice filter) is destructured at the top; ensure the
			// practice filter is set for every navigation path
			if (filterType === "sandbox") {
				this.filters.practice = ["sandbox"];
			}

			if (filterType === "leaderboard") {
				this.filters.practice = ["leaderboard"];
			}
			this.isTopicsInitialized = false;
			this.buildTopicsOnce();
			console.log(this.filters, "filtees");
			this.$nextTick(() => {
				if (this.filters.practice?.length) {
					this.filterCount = 1;
				}
			});
		},
		isProjectAssessment(assessment) {
			return assessment.assessmentType === "sandbox";
		},
		handleInput(val) {
			if (this.prevSearch && val === "") {
				this.skipWatcher = true; // block watcher
				this.$router.replace({ query: {} });
				this.currentPage = 1;
				this.getPublicAssessments();
				this.getAllAssessments();
				return;
			}
			this.prevSearch = val;
		},
		async getAllAssessments() {
			try {
				const filter = {};

				// 🔹 Levels
				if (this.filters.levels?.length) {
					filter.intDifficulty = this.filters.levels;
				}

				// 🔹 Duration
				if (this.filters.duration?.length) {
					filter.testDuration = this.filters.duration;
				}

				// 🔹 Topic
				if (this.filters.topic) {
					filter.topicName = this.filters.topic;
				}

				// 🔹 Practice → assessmentType
				if (this.filters.practice?.length) {
					filter.assessmentType = [...this.filters.practice];
				}

				// 🔹 Price
				if (
					this.filters.priceFrom !== undefined &&
					this.filters.priceTo !== undefined
				) {
					filter.priceFrom = this.filters.priceFrom;
					filter.priceTo = this.filters.priceTo;
				}

				// 🔹 Category
				if (this.filters.categoryIDs?.length) {
					filter.categoryIDs = this.filters.categoryIDs;
				}

				// 🔹 SubCategory
				if (this.filters.subCategoryIDs?.length) {
					filter.subCategoryIDs = this.filters.subCategoryIDs;
				}

				// if (this.filters.leaderboard) {
				// 	filter.leaderboardCategory = this.filters.leaderboard;
				// }

				// 🔹 Sort
				let sortBy = undefined;

				if (this.filters.sortBy) {
					const [column, order] = this.filters.sortBy.split("_");
					sortBy = {
						column,
						order: order === "true",
					};
				}

				const payload = {
					email: this.userInfo.email,
					...(Object.keys(filter).length && { filter }),
					...(sortBy && { sortBy }),
					searchQuery: this.searchQuery || "",
				};

				const res = await getAllAssessments(payload);

				if (res.status === 200) {
					const data = res.data.data;
					this.allAssessmentsData.completed = data.completed || [];
					this.allAssessmentsData.upcoming = data.upcoming || [];
					this.allAssessmentsData.ongoing = data.ongoing || [];
					this.allAssessmentsMaxPrice = data.maxFinalPrice;
					if (!this.isTopicsInitialized) {
						this.buildTopicsOnce();
					}
				}
			} catch (e) {
				console.log(e);
			}
		},
		isPageRefresh() {
			const nav = performance.getEntriesByType?.("navigation");
			if (nav && nav.length) return nav[0].type === "reload";
			return performance.navigation?.type === 1;
		},
		clearSourceQuery() {
			const { source: _s, ...remainingQuery } = this.$route.query;
			return this.$router.replace({ query: remainingQuery });
		},
		async autoOpenAssessment(searchQuery) {
			const allLoaded = [
				...(this.publicAssessment || []),
				...(this.allAssessmentsData.completed || []),
				...(this.allAssessmentsData.upcoming || []),
				...(this.allAssessmentsData.ongoing || []),
			];
			const match = allLoaded.find(
				(a) =>
					a.testName && a.testName.toLowerCase() === searchQuery.toLowerCase()
			);
			if (!match) return;
			// Clear &source from URL first, then open — prevents re-trigger on back navigation
			await this.clearSourceQuery();
			if (match.noOfAttemptsTaken != 0) {
				this.viewMarks(match, match?.config?.test);
			} else {
				this.viewTestDetails(match, "private", !this.isLaptop, false);
			}
		},
		handleFilterCount(count) {
			console.log(count, "helloooo");

			this.filterCount = count;
		},
		onScroll(e) {
			if (window.innerWidth > 1028) return;

			const { target } = e;

			const isNearBottom =
				target.scrollTop + target.clientHeight >= target.scrollHeight - 20;

			if (isNearBottom && !this.loadingMore) {
				if (this.pageEnd < this.total) {
					this.loadingMore = true;
					this.currentPage++;
					this.getPublicAssessments();
				}
			}
		},
		buildTopicsOnce() {
			if (this.isTopicsInitialized) return;

			const topicsSet = new Set();

			// public
			this.publicAssessment.forEach((item) => {
				const topic = item.topicName || item.topicTitle;
				if (topic) topicsSet.add(topic);
			});

			// all assessments
			["completed", "upcoming", "ongoing"].forEach((type) => {
				(this.allAssessmentsData[type] || []).forEach((item) => {
					const topic = item.topicName || item.topicTitle;
					if (topic) topicsSet.add(topic);
				});
			});

			this.stableTopics = Array.from(topicsSet);
			this.isTopicsInitialized = true;
		},
		checkbetween(x, min, max) {
			return x > min && x < max;
		},
		isValidPage(page) {
			const totalPages = Math.ceil(this.total / this.pageCount);
			return /^\d*$/.test(page) && page > 0 && page <= totalPages;
		},

		onPageChange(newPage) {
			this.currentPage = newPage;

			this.getPublicAssessments();
		},

		async goToPage(pageNumberToGo) {
			const totalPages = Math.ceil(this.total / this.pageCount);

			let page = Number(pageNumberToGo);

			if (!page || page < 1) {
				page = 1; // min clamp
			} else if (page > totalPages) {
				page = totalPages; // max clamp
			}

			this.currentPage = page;

			await this.getPublicAssessments();

			this.pageNumberToGo = "";
		},
		async handleSearch() {
			if (!this.searchQuery || !this.searchQuery.trim()) return;
			if (this.activeAssessmentTab == "all") {
				this.currentPage = 1;
			}
			await this.getPublicAssessments();
			await this.getAllAssessments();
		},
		async handleApplyFilters(appliedFilters, isUserAction = false, count) {
			// Only close if NOT from query

			this.filters = appliedFilters;
			this.filterCount = count;
			this.currentPage = 1;
			this.publicAssessment = [];
			if (isUserAction && !this.isLaptop) {
				this.$bvModal.hide("asmntfilter");
			}
			await this.getPublicAssessments(); // API call happens here
			await this.getAllAssessments();
		},
		checkScreenSize() {
			this.isLaptop = window.innerWidth >= 1028;
		},
		async getPublicAssessments() {
			console.log("helloo ");

			this.isLoadingAssessments = true;
			// this.isManualClear = false; // Reset manual clear shimmer
			try {
				const filter = {};

				// 🔹 Levels
				if (this.filters.levels?.length) {
					filter.intDifficulty = this.filters.levels;
				}

				// 🔹 Duration
				if (this.filters.duration?.length) {
					filter.testDuration = this.filters.duration;
				}

				// 🔹 Topic
				if (this.filters.topic) {
					filter.topicName = this.filters.topic;
				}

				// 🔹 Practice → assessmentType
				if (this.filters.practice?.length) {
					filter.assessmentType = [...this.filters.practice];
				}

				// 🔹 Price
				if (
					this.filters.priceFrom !== undefined &&
					this.filters.priceTo !== undefined
				) {
					filter.priceFrom = this.filters.priceFrom;
					filter.priceTo = this.filters.priceTo;
				}

				// 🔹 Category
				if (this.filters.categoryIDs?.length) {
					filter.categoryIDs = this.filters.categoryIDs;
				}

				// 🔹 SubCategory
				if (this.filters.subCategoryIDs?.length) {
					filter.subCategoryIDs = this.filters.subCategoryIDs;
				}

				// if (this.filters.leaderboard) {
				// 	filter.leaderboardCategory = this.filters.leaderboard;
				// }

				// 🔹 Sort
				let sortBy = undefined;

				if (this.filters.sortBy) {
					const [column, order] = this.filters.sortBy.split("_");
					sortBy = {
						column,
						order: order === "true",
					};
				}

				const payload = {
					page: this.currentPage - 1,
					count: this.pageCount,
					email: this.userInfo.email,
					// home: true,
					...(Object.keys(filter).length && { filter }),
					...(sortBy && { sortBy }),
					searchQuery: this.searchQuery || "",
				};

				const response = await getPublicAssessments(payload);
				if (response.status === 200) {
					this.isLoadingAssessments = false;
					this.loadingMore = false;
					if (this.currentPage != 1 && !this.isLaptop) {
						this.publicAssessment = [
							...this.publicAssessment,
							...response.data.data.data,
						];
					} else {
						this.publicAssessment = response.data.data.data;
					}
					this.total = response.data.data.total; // backend returns totalPlayers

					this.pageStart = response.data.data.pageStart; // +1 for UI readability

					this.pageEnd = response.data.data.pageEnd;
					// this.currentPage = response.data.data.page + 1; // backend is 0-based, UI is 1-based
					// this.topics = response.data.data.allTopicNames || [];
					if (!this.isTopicsInitialized) {
						this.buildTopicsOnce();
					}
					this.maxPricerange = response.data.data.maxFinalPrice || 0;
					this.pageCount = this.pageCount;
				}
			} catch (error) {
				console.error(error);
			} finally {
				this.isLoadingAssessments = false;
				// this.isManualClear = false;
			}
		},
		handleFilterChange(filterData) {
			this.filters[filterData.type] = filterData.value;
			this.getPublicAssessments();
		},
		getAssessmentType() {
			if (!this.filters.practice?.length) return "assessment";

			if (this.filters.practice.includes("sandbox")) return "sandbox";

			return "assessment";
		},
		handleBack() {
			if (this.$route.query.from == "profilevisibility") {
				if (window.history.length > 1) {
					this.$router.back();
				} else {
					this.$router.replace({ name: "ProfileVisibility" });
				}
				return;
			}
			console.log("In the Assessment");
			if (this.$route.query.from == "Leaderboard") {
				this.$router.push({
					name: "Leaderboard",
					query: { type: "assessment" },
				});
				return;
			}
			if (this.$route.query.from == "streaks") {
				this.$router.back();
				return;
			}
			// Came from the COMPANY ASSESSMENTS tag on the dashboard
			if (this.$route.query.from == "companyAssessments") {
				this.$router.back();
				return;
			}
			if (this.$route.query.frompage && this.$route.query.notif) {
				this.$router.push({ name: this.$route.query.frompage });
				return;
			}
			if (this.$route.query.redirectTraining) {
				window.location.href = decodeURIComponent(
					this.$route.query.redirectTraining
				);
				return;
			}
			const tabToSend =
				this.activeAssessmentTab === "all"
					? "completed"
					: this.activeAssessmentTab;

			this.$router.push({
				name: "AssessmentMarketplace",
				query: {
					tab: tabToSend,
				},
			});
		},
		getSortObject() {
			if (!this.filters.sortBy) {
				return {
					column: "createdAt",
					order: false,
				};
			}

			const [column, order] = this.filters.sortBy.split("_");

			return {
				column,
				order: order === "true",
			};
		},
		async clearFilters(wasApplied) {
			this.filters = {};
			this.$bvModal.hide("asmntfilter");
			this.filterCount = 0;

			this.$router.replace({ query: {} });
			if (wasApplied) {
				this.currentPage = 1;
				await this.getAllAssessments();
				await this.getPublicAssessments();
			}
			this.buildTopicsOnce();
		},
		roundToTwo(num) {
			return Math.round(num);
		},
		searchPublic(search) {
			this.loaderStatus = true;
			this.search = search;
			if (this.currentPage === 1) {
				this.getPublicAssessments();
			} else {
				this.currentPage = 1;
			}
		},
		shortenLink(link) {
			return "https://.../" + link.split("/").slice(-1);
		},
		updatePageCount(pageCount) {
			this.pageCount = pageCount;
			this.currentPage = 1;
			this.getPublicAssessments();
		},
		copyToClipboard(text) {
			this.$copyToClipboard(text);
		},

		checkDigit(event) {
			if (event.key.length === 1 && isNaN(Number(event.key))) {
				event.preventDefault();
			}
		},
	},
	watch: {
		searchQuery(val, oldVal) {
			if (this.skipWatcher) {
				this.skipWatcher = false;
				return; //skip duplicate call
			}

			if (oldVal && val === "") {
				this.$router.replace({ query: {} });
				this.handleSearch();
			}
		},
		activeAssessmentTab() {
			this.currentPage = 1;
		},
		currentPage() {
			this.$router.replace({
				query: {
					page: this.currentPage,
					count: this.pageCount,
					searchQuery: this.$route.query.searchQuery,
					testID: this.$route.query.testID,
					groupID: this.$route.query.groupID,
					subCategoryTitle: this.$router?.query?.subCategoryTitle,
					category: this.$route.query.category,
					subCategory: this.$route.query.subCategory,
					from: this.$route.query.from,
				},
			});
		},
		"$route.query.searchQuery"(newVal) {
			this.searchQuery = newVal || "";
			this.activeAssessmentTab = "all"; // Ensure we are on the Library tab to see results
			this.currentPage = 1;
			this.publicAssessment = []; // Clear current results to show shimmer
			this.getPublicAssessments();
			this.getAllAssessments();
		},
	},
};
</script>

<style>
.vue-slider-dot-handle {
	cursor: pointer;
	width: 100%;
	height: 100%;
	border-radius: 50%;
	background-color: #fff;
	box-sizing: border-box;
	box-shadow: 0.5px 0.5px 2px 1px rgba(0, 0, 0, 0.32);
	position: relative;
	border: 1px solid #20639b;
}
.vue-slider-process {
	background-color: #20639b;
}
.vue-slider-dot-handle::after {
	content: "";
	position: absolute;
	top: 50%;
	left: 50%;
	width: 6px;
	height: 6px;
	background-color: #20639b;
	border-radius: 50%;
	transform: translate(-50%, -50%);
}

.allocateradios
	.custom-radio
	.custom-control-input:checked
	~ .custom-control-label::after {
	background-image: none;
	border: 2px solid #20639b;
	border-radius: 50%;
}

.allocateradios .custom-control-input:checked ~ .custom-control-label::before {
	color: #fff;
	border-width: 4px;
	border-color: #fff;
	background-color: #20639b;
}

.allocateradios .custom-control-label {
	font-family: "Lato", sans-serif;
	font-weight: 500;
	font-size: 14px;
	color: #3a3c40;
	line-height: 24px;
}

.allocateradios .custom-control-label::before {
	border: 2px solid #20639b;
}

.allocateradios .custom-control-input[disabled] ~ .custom-control-label,
.custom-control-input:disabled ~ .custom-control-label {
	color: #3a3c40;
}

.allocateradios .custom-control-input[disabled] ~ .custom-control-label::before,
.custom-control-input:disabled ~ .custom-control-label::before {
	top: 3px;
	background-color: #ffffff;
}
.allocateradios .error .custom-control-label::before {
	border: 2px solid #eb0002;
}
.filter-card {
	border-bottom: 1px solid #eee;
	padding: 10px 0;
}

.filter-header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	cursor: pointer;
	font-weight: 700;
	color: #344054;
	font-size: 14px;
	font-family: "Lato", sans-serif;
}

.filter-header img {
	transition: transform 0.25s ease;
}

.rotate {
	transform: rotate(180deg);
}

.filter-body {
	padding: 10px 0;
	display: flex;
	flex-direction: column;
	gap: 8px;
}
/* end of filter */
.assesspro-cards {
	background-color: #fcfcfc;
	box-shadow: 0px 4px 15px 0px #c4c4c480;
	width: 49%;
	border: none;
	margin-bottom: 12px;
	padding: 10px;
	border-radius: 5px;
}

.asp-top-card {
	border-bottom: 1px solid #d9d9d9;
	padding-bottom: 13px;
	display: flex;
	align-items: flex-start;
	width: 100%;
	position: relative;
}

.assesspro-cards-blue {
	background: #e9f0f5;
	border: none;
	margin-bottom: 12px;
	padding: 10px;
	border-radius: 5px;
}

.assesspro-overflow {
	height: calc(100vh - 335px);
	overflow: auto;
	padding: 13px 6px 0px 13px;
}

.asp-completed-tag {
	font-family: "Lato", sans-serif;
	font-size: 12px;
	font-weight: 500;
	color: var(--cv-green);
	background-color: #f6f9fb;
	border-radius: 8px;
	padding: 1px 19px;
}

.asp-when-no-tab {
	height: calc(100vh - 148px);
	overflow: auto;
	padding: 15px;
}

.asp-when-no-tab::-webkit-scrollbar {
	scroll-behavior: smooth;
	width: 0px !important;
	height: 0px !important;
	background-color: transparent !important;
}

.asp-when-no-tab {
	-ms-overflow-style: none; /* IE and Edge */
	scrollbar-width: none; /* Firefox */
}

.asp-sel-tab {
	font-family: "Lato", sans-serif;
	font-size: 16px;
	font-weight: 700;
	color: #20639b;
	padding: 12px 14px;
	position: relative;
	cursor: pointer;
}

.asp-unsel-tab {
	font-family: "Lato", sans-serif;
	font-size: 16px;
	font-weight: 500;
	color: #000000;
	padding: 12px 14px;
	cursor: pointer;
}

.asp-sel-line {
	position: absolute;
	height: 4px;
	width: 100%;
	border-radius: 12px;
	background-color: #20639b;
	bottom: 0px;
	left: 0px;
}

.asp-white-timer {
	border-radius: 7px;
	background-color: #ffffff;
	padding: 3px 6px;
	position: absolute;
	font-family: "Lato", sans-serif;
	font-size: 11px;
	font-weight: 600;
	color: #3a3c40;
	display: flex;
	align-items: center;
	right: -7px;
	top: -8px;
}

.greytool-box {
	background: #20639b30;
	display: flex;
	align-items: center;
	justify-content: center;
	position: absolute;
	height: 22px;
	width: 30px;
	left: 0px;
	top: 0px;
	border-radius: 7px 10px 10px 0px;
}

.greytool-box:hover {
	box-shadow: 0px 1px 4px 0px #00000026;
}

.asp-right-modal-overflow {
	max-height: calc(100vh - 580px);
	overflow: auto;
}

.asp-testdetails-bluebox {
	border-radius: 12px;
	background-color: #f6f9fb;
}

.asp-modal-blue-card {
	border-radius: 14px;
	background: #f2f7fb;
	padding: 20px;
	display: flex;
	flex-wrap: wrap;
	/* height: 420px; */
}

.asp-modal-blue-card > * {
	flex: 1 1 50%;
}

#asp-greytool .arrow::before {
	right: -150px !important;
	border-width: 0.4rem 0.4rem 0.4rem 0.4rem !important;
	border-left-color: #d9d9d9 !important;
	border-right-color: transparent !important;
}

#asp-greytool {
	top: 6px !important;
	left: -187px !important;
}

#asp-greytool .tooltip-inner {
	text-align: left !important;
	padding: 10px;
}
.laptop-body-height {
	height: calc(100vh - 148px);
}
.search-box-bluecont {
	padding: 12px;
	background: #f9fcfd;
	border-radius: 6px;
}
.color-2E425D {
	color: #2e425d !important;
}
#asmntfilter .modal-body {
	padding: 0;
}
@media (max-width: 1028px) {
	.mob-padding-0 {
		padding: 0 !important;
	}
	.mob-w-100 {
		width: 100% !important;
	}
	.mob-mr-0 {
		margin-right: 0 !important;
	}
	.assesspro-overflow {
		height: calc(100% - 110px);
		overflow-x: hidden;
		margin: 0;
		padding: 0;
	}
	.asp-mobleft-container {
		height: calc(100dvh - 80px);
		overflow: hidden;
		padding-bottom: env(safe-area-inset-bottom);
	}
	.padding-top-55px {
		padding-top: 55px;
	}
	.cuo-assesspro-height {
		height: calc(100dvh - 192px) !important;
	}
	.cand-dashboard-maincontainer-loggedout-asmnt {
		top: 0 !important;
		height: 100dvh !important;
	}
	.assesspro-overflow-loggedout {
		height: calc(100dvh - 215px) !important;
	}
	.asp-left-loggedout {
		height: calc(100vh - 150px) !important;
	}
	#asmntfilter___BV_modal_outer_ {
		z-index: 1050 !important;
	}
	.topmob-header {
		top: env(safe-area-inset-top) !important;
		padding-top: 0 !important;
	}
}
.w-50px {
	width: 50px;
}
.cuo-assesspro-height {
	height: calc(100vh - 290px);
}
.cand-dashboard-maincontainer-loggedout-asmnt {
	height: calc(100vh - 72px);
	top: 72px;
	padding: 15px;
}
.assesspro-overflow-loggedout {
	height: calc(100vh - 290px);
}
.asp-left-loggedout {
	height: calc(100vh - 170px);
}
</style>
